import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-fluid p-jc-center kn-height-full" }
const _hoisted_2 = { class: "p-col-12" }
const _hoisted_3 = { class: "p-m-5" }
const _hoisted_4 = {
  key: 0,
  class: "p-inputgroup"
}
const _hoisted_5 = { class: "p-float-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Card = _resolveComponent("Card")
  const _component_UserAttributesLovValueDialog = _resolveComponent("UserAttributesLovValueDialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Card, { style: {"width":"100%","margin-bottom":"2em"} }, {
          header: _withCtx(() => [
            _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
              start: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('managers.usersManagement.attributes')), 1)
              ]),
              _: 1
            })
          ]),
          content: _withCtx(() => [
            _createVNode("div", _hoisted_3, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.attributes, (attribute) => {
                return (_openBlock(), _createBlock("div", {
                  class: "p-field",
                  key: attribute.attributeId
                }, [
                  (_ctx.modelValue[attribute.attributeId])
                    ? (_openBlock(), _createBlock("div", _hoisted_4, [
                        _createVNode("span", _hoisted_5, [
                          _createVNode(_component_InputText, {
                            disabled: attribute.lovId,
                            class: "p-inputtext p-component kn-material-input",
                            id: attribute.attributeId,
                            onInput: ($event: any) => (_ctx.onInputChange(attribute, $event.target.value)),
                            type: "text",
                            modelValue: _ctx.userAttributesForm[attribute.attributeId][attribute.attributeName],
                            "onUpdate:modelValue": ($event: any) => (_ctx.userAttributesForm[attribute.attributeId][attribute.attributeName] = $event)
                          }, null, 8, ["disabled", "id", "onInput", "modelValue", "onUpdate:modelValue"]),
                          _createVNode("label", {
                            for: attribute.attributeName
                          }, _toDisplayString(attribute.attributeName), 9, ["for"])
                        ]),
                        (attribute.lovId)
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              icon: "pi pi-pencil",
                              class: "p-button-text p-button-rounded p-button-plain",
                              onClick: ($event: any) => (_ctx.openLovValuesDialog(attribute))
                            }, null, 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_Button, {
                          icon: "pi pi-times-circle",
                          class: "p-button-text p-button-rounded p-button-plain",
                          onClick: ($event: any) => (_ctx.eraseAttribute(attribute))
                        }, null, 8, ["onClick"])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_UserAttributesLovValueDialog, {
      attribute: _ctx.selectedAttribute,
      selection: _ctx.initialSelection,
      dialogVisible: _ctx.lovDialogVisible,
      onSaveLovValues: _ctx.onSaveLovValues,
      onCloseDialog: _cache[1] || (_cache[1] = ($event: any) => {;(_ctx.lovDialogVisible = false), (_ctx.selectedAttribute = null)})
    }, null, 8, ["attribute", "selection", "dialogVisible", "onSaveLovValues"])
  ], 64))
}